import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import StatefulMultiSelect from "@khanacademy/react-multi-select";

export default class ProfitReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            startDate:moment().toDate(),
            endDate:moment().toDate(),
            isLoading:false,
            getProfitReportUrl:'/api/v1/portal/portal-admin/profit-report',
            profitReportData:[],
            downloadReportName:'Profit Report',
            selectedCustomers:[],
            customers:[],
            url: "/api/v1/portal/customers/all/for-dropdown-menu",
        };
        this.handleStartDateChange = this.handleStartDateChange.bind(this);
        this.handleEndDateChange = this.handleEndDateChange.bind(this);
        this.handleCustomerSelection = this.handleCustomerSelection.bind(this);
    }
    componentDidMount() {
        let options = [];   
        return fetch(this.state.url, {
          method: "GET",
          mode: "cors",
          cache: "no-cache",
          credentials: "same-origin",
          headers: {
            "Authorization": 'Bearer ' + window.api_token
            , "Accept": 'application/json'
          },
        }).then((responseText) => {
          let response = responseText.json();
          response.then((response) => {
              response.map((customer)=>{
                options.push({
                    label : customer.company.short_name+'-'+customer.name,
                    value : customer.id
                });
            });
            this.setState({
              customers: options,
              isLoading: false
            });
          });
        });
    }
    handleStartDateChange(date) {
        this.setState({startDate: date})
    }
    handleEndDateChange(date) {
        this.setState({endDate: date})
    }
    handleCustomerSelection(selectedCustomers) {
        this.setState({selectedCustomers});
    }
    handleInvoicedJobsReportGeneration(e) {
        this.setState({isLoading: true});
        let url = this.state.getProfitReportUrl;
        return fetch(url, {
          method: "POST",
          mode: "cors",
          cache: "no-cache",
          credentials: "same-origin",
          headers: {
            "Authorization": 'Bearer ' + window.api_token
            , "Accept": 'application/json'
          },
          body: JSON.stringify({
            customer_ids: this.state.selectedCustomers,
            start_date:moment(this.state.startDate).format("YYYY-MM-DD"),
            end_date:moment(this.state.endDate).format("YYYY-MM-DD")
          }),
        }).then((responseText) => {
          let response = responseText.json();
          response.then((response) => {
            this.setState({
                profitReportData: response.jobs,
                isLoading: false
            })
          });
        });
    }
    download(filename, text) {
        filename = filename+' From '+moment(this.state.startDate).format("YYYY-MM-DD")+' To '+moment(this.state.endDate).format("YYYY-MM-DD")+'.csv';
        let element = document.createElement('a');
        element.setAttribute('href','data:text/plain;charset=utf-8,' + encodeURIComponent(text));
        element.setAttribute('download', filename);
        element.style.display = 'none';
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
      }
    render() {
        let profitedRecords = [];
        const {selectedCustomers} = this.state;
        let downloadableCsvDataInvoiced = "JOB REF,REG/VIN,CUSTOMER,DRIVER,STATUS,DRIVER COMPLETED DATE,JOB PRICE,MILEAGE,ADMIN FEE,FUEL INCL,DRIVER PRICE,Driver Expense,Fuel,CUSTOMER CHARGE VEHICLE MOVEMENTS,Vehicle Movements,Toll Road,Waitingtime,Storage,Breakdown,Travel,Car Wash,Parts,Transport Services,Hotel,Electric Charge Cost,Electric Charging Time,Truck Fuel,Truck Travel,Air,Food,Water,Coolant,Parking,PROFIT,GROSS PROFIT %\n";
        if(this.state.profitReportData.length > 0){
            let jobTotals = 0.00;
            let adminTotals = 0.00;
            let driverTotals = 0.00;
            let expTotals = 0.00;
            let profitTotals = 0.00;
            let grossTotals = 0.00;
            let profitTotals_customer = 0.00;

            let expenses_approval_fuelTotal = 0.00;
            let vehicle_movementsTotal = 0.00;
            let toll_roadTotal = 0.00;
            let waitingtimeTotal = 0.00;
            let storageTotal = 0.00;
            let breakdownTotal = 0.00;
            let travelTotal = 0.00;
            let car_washTotal = 0.00;
            let partsTotal = 0.00;
            let transport_servicesTotal = 0.00;
            let hotelTotal = 0.00;
            let expense_price = 0.00;
            let cost_in_pence_final_total = 0.00;
            let customer_charged_vehicle_movementsSum = 0.00;
            let jobs_cost_in_pence_total = 0.00;
            let electric_charge_costTotal = 0.00;
            let electric_charging_timeTotal = 0.00;
            let truck_fuelTotal = 0.00;
            let truck_travelTotal = 0.00;
            let airTotal = 0.00;
            let foodTotal = 0.00;
            let waterTotal = 0.00;
            let coolantTotal = 0.00;
            let parkingTotal = 0.00;

            this.state.profitReportData.map((currentJob, index) => {
                let joburl = "/jobs/view/"+currentJob.id;

                let jobTotalPrice = parseFloat(currentJob.job_price);
                let dPrice = parseFloat(currentJob.driver_price);
                let ePrice = parseFloat(currentJob.expenses_price);
                let adminFPrice = (currentJob.admin_fee_in_pence) ? (parseFloat(currentJob.admin_fee_in_pence)) / 100 : 0.00;

                let fuel_price = parseFloat((currentJob.expenses_approval_fuel_total/100).toFixed(2));
                let vehicle_movements = parseFloat((currentJob.vehicle_movements/100).toFixed(2));
                let toll_road = parseFloat((currentJob.toll_road/100).toFixed(2));
                let waitingtime = parseFloat((currentJob.waitingtime/100).toFixed(2));
                let storage = parseFloat((currentJob.storage/100).toFixed(2));
                let breakdown = parseFloat((currentJob.breakdown/100).toFixed(2));
                let travel = parseFloat((currentJob.travel/100).toFixed(2));
                let car_wash = parseFloat((currentJob.car_wash/100).toFixed(2));
                let parts = parseFloat((currentJob.parts/100).toFixed(2));
                let transport_services = parseFloat((currentJob.transport_services/100).toFixed(2));
                let hotel = parseFloat((currentJob.hotel/100).toFixed(2));
                let electric_charge_cost = parseFloat((currentJob.electric_charge_cost/100).toFixed(2));
                let electric_charging_time = parseFloat((currentJob.electric_charging_time/100).toFixed(2));
                let truck_fuel = parseFloat((currentJob.truck_fuel/100).toFixed(2));
                let truck_travel = parseFloat((currentJob.truck_travel/100).toFixed(2));
                let air = parseFloat((currentJob.air/100).toFixed(2));
                let food = parseFloat((currentJob.food/100).toFixed(2));
                let water = parseFloat((currentJob.water/100).toFixed(2));
                let coolant = parseFloat((currentJob.coolant/100).toFixed(2));
                let parking = parseFloat((currentJob.parking/100).toFixed(2));
                
                let expense_approval_total = 0.00;
                let cost_in_pence_final_total = 0.00;
                let expense_approval_driver_total_pay = 0.00;
                let customer_charged_vehicle_movementsSum = 0;
                // not using `expense_price` value any more!
                if (currentJob.fuel_included_in_job_price === 1) {
                    expense_price = ((fuel_price) + (toll_road) + (travel) + (hotel));
                } else {
                    expense_price = ((toll_road) + (travel) + (hotel));
                }
                let customerPaidExpensesPrice = parseFloat(currentJob.customer_paid_expenses_price);
                let jobProfitPlus = ((adminFPrice) + (dPrice) + (customerPaidExpensesPrice));
                let jobProfit = ((jobTotalPrice) - (jobProfitPlus));
                // let jobProfitPlus = ((adminFPrice) + (dPrice) + (parseFloat(currentJob.hotel)) + (parseFloat(currentJob.trael)) + (parseFloat(currentJob.toll_road)));
                // let profitTotals_cust = ((jobTotalPrice) - (jobProfitPlus));
                let expenses_approval_fuel_total = parseFloat(currentJob.expenses_approval_fuel_total).toFixed(2);

                let jobTotalCosts = (ePrice) + (dPrice);
                let grossProfit = jobTotalPrice - jobTotalCosts;
                let grossProfitOverTotal = grossProfit / jobTotalPrice;
                // let grossProfitPercentage = grossProfitOverTotal * 100;
                let grossProfitPercentage = (jobProfit/ (jobTotalPrice/100));
                if (currentJob.expense_data && Object.keys(currentJob.expense_data).length > 0) {
                    let cost_in_pence_total = 0.00;
                    for (var j = 0; j < currentJob.expense_data.expense_json.length; j++) {
                         cost_in_pence_total += parseFloat(parseFloat(currentJob.expense_data.expense_json[j].cost_in_pence)) / 100;
                    }
                    jobs_cost_in_pence_total = cost_in_pence_total;
                }
                if(currentJob.expense_approvals.length>0)
                {
                    for(var i=0;i<currentJob.expense_approvals.length;i++)
                    {
                        expense_approval_total = expense_approval_total + (parseFloat(currentJob.expense_approvals[i].client_charge_in_pence)) / 100;
                        expense_approval_driver_total_pay = expense_approval_driver_total_pay + (parseFloat(currentJob.expense_approvals[i].driver_pay_in_pence)) / 100;
                    }
                }
                
                let customer_charged_vehicle_movementsTotal = (jobTotalPrice + expense_approval_total) - (expense_approval_driver_total_pay);
                customer_charged_vehicle_movementsSum = (customer_charged_vehicle_movementsSum+customer_charged_vehicle_movementsTotal);

                grossProfitPercentage = grossProfitPercentage.toFixed(2);

                jobTotals = ((jobTotals) + (jobTotalPrice));
                adminTotals = ((adminTotals) + (adminFPrice));
                driverTotals = ((driverTotals) + (dPrice));
                expTotals = ((expTotals) + (ePrice));
                profitTotals = ((profitTotals) + (jobProfit));
                grossTotals = ((grossTotals) + (grossProfitPercentage));
                // profitTotals_customer = ((profitTotals_customer) + (profitTotals_cust));
                
                expenses_approval_fuelTotal = ((expenses_approval_fuelTotal) + (parseFloat(currentJob.expenses_approval_fuel_total)));
                vehicle_movementsTotal = ((vehicle_movementsTotal) + (parseFloat(vehicle_movements)));
                toll_roadTotal = ((toll_roadTotal) + (parseFloat(toll_road)));
                waitingtimeTotal = ((waitingtimeTotal) + (parseFloat(waitingtime)));
                storageTotal = ((storageTotal) + (parseFloat(storage)));
                breakdownTotal = ((breakdownTotal) + (parseFloat(breakdown)));
                travelTotal = ((travelTotal) + (parseFloat(travel)));
                car_washTotal = ((car_washTotal) + (parseFloat(car_wash)));
                partsTotal = ((partsTotal) + (parseFloat(parts)));
                transport_servicesTotal = ((transport_servicesTotal) + (parseFloat(transport_services)));
                hotelTotal = ((hotelTotal) + (parseFloat(hotel)));
                electric_charge_costTotal = ((electric_charge_costTotal) + (parseFloat(electric_charge_cost)));
                electric_charging_timeTotal = ((electric_charging_timeTotal) + (parseFloat(electric_charging_time)));
                truck_fuelTotal = ((truck_fuelTotal) + (parseFloat(truck_fuel)));    
                truck_travelTotal = ((truck_travelTotal) + (parseFloat(truck_travel)));
                airTotal = ((airTotal) + (parseFloat(air)));
                foodTotal = ((foodTotal) + (parseFloat(food)));
                waterTotal = ((waterTotal) + (parseFloat(water)));
                coolantTotal = ((coolantTotal) + (parseFloat(coolant)));
                parkingTotal = ((parkingTotal) + (parseFloat(parking)));
                cost_in_pence_final_total = ((cost_in_pence_final_total)+(parseFloat(jobs_cost_in_pence_total)));

                profitedRecords.push(
                        <tr key={index}>
                            <td className="job-ref-font16"><a href={joburl}>{currentJob.id}</a></td>
                            <td>{currentJob.vehicle.registration_number}</td>        
                            <td>{currentJob.customer.name}</td>        
                            <td>{currentJob.driver?.user?.first_name} {currentJob.driver?.user?.last_name}</td>        
                            <td>{currentJob.status}</td> 
                            <td>{((currentJob.driver_completed_at) ? moment(currentJob.driver_completed_at).format("DD/MM/YY") : "")}</td>    
                            <td>&pound;{jobTotalPrice.toFixed(2)}</td>
                            <td>{currentJob.distance_in_miles}</td>
                            <td>&pound;{adminFPrice}</td>
                            <td>{currentJob.fuel_included_in_job_price === 1 ? 'YES' : 'NO'}</td>
                            <td>&pound;{dPrice.toFixed(2)}</td>
                            <td>&pound;{jobs_cost_in_pence_total.toFixed(2)}</td>
                            
                            <td>&pound;{expenses_approval_fuel_total}</td>
                            <td>&pound;{customer_charged_vehicle_movementsTotal.toFixed(2)}</td>
                            <td>&pound;{(currentJob.vehicle_movements/100).toFixed(2)}</td>
                            <td>&pound;{(currentJob.toll_road/100).toFixed(2)}</td>
                            <td>&pound;{(currentJob.waitingtime/100).toFixed(2)}</td>
                            <td>&pound;{(currentJob.storage/100).toFixed(2)}</td>
                            <td>&pound;{(currentJob.breakdown/100).toFixed(2)}</td>
                            <td>&pound;{(currentJob.travel/100).toFixed(2)}</td>
                            <td>&pound;{(currentJob.car_wash/100).toFixed(2)}</td>
                            <td>&pound;{(currentJob.parts/100).toFixed(2)}</td>
                            <td>&pound;{(currentJob.transport_services/100).toFixed(2)}</td>
                            <td>&pound;{(currentJob.hotel/100).toFixed(2)}</td>
                            <td>&pound;{(currentJob.electric_charge_cost/100).toFixed(2)}</td>
                            <td>&pound;{(currentJob.electric_charging_time/100).toFixed(2)}</td>
                            <td>&pound;{(currentJob.truck_fuel/100).toFixed(2)}</td>
                            <td>&pound;{(currentJob.truck_travel/100).toFixed(2)}</td>
                            <td>&pound;{(currentJob.air/100).toFixed(2)}</td>
                            <td>&pound;{(currentJob.food/100).toFixed(2)}</td>
                            <td>&pound;{(currentJob.water/100).toFixed(2)}</td>
                            <td>&pound;{(currentJob.coolant/100).toFixed(2)}</td>
                            <td>&pound;{(currentJob.parking/100).toFixed(2)}</td>
                            <td>&pound;{jobProfit.toFixed(2)}</td>
                            <td>{grossProfitPercentage}%</td>
                            {/*<td>&pound;{profitTotals_cust.toFixed(2)}</td>*/}
                        </tr>
                );
                downloadableCsvDataInvoiced = downloadableCsvDataInvoiced +
                    currentJob.id+','+
                    currentJob.vehicle.registration_number+','+
                    currentJob.customer.name+','+
                    currentJob.driver?.user?.first_name  + ' ' + currentJob.driver?.user?.last_name  +','+
                    currentJob.status+','+
                    ((currentJob.driver_completed_at) ? moment(currentJob.driver_completed_at).format("DD/MM/YY") : "")+','+
                    (jobTotalPrice.toFixed(2))+','+
                    (currentJob.distance_in_miles)+','+
                    (adminFPrice)+','+
                    (((currentJob.fuel_included_in_job_price)&&(currentJob.fuel_included_in_job_price === 1)) ? 'YES' : 'NO')+','+
                    (dPrice.toFixed(2))+','+
                    (jobs_cost_in_pence_total.toFixed(2))+','+

                    expenses_approval_fuel_total+','+
                    customer_charged_vehicle_movementsTotal.toFixed(2)+','+
                    ((currentJob.vehicle_movements/100).toFixed(2))+','+
                    ((currentJob.toll_road/100).toFixed(2))+','+
                    ((currentJob.waitingtime/100).toFixed(2))+','+
                    ((currentJob.storage/100).toFixed(2))+','+
                    ((currentJob.breakdown/100).toFixed(2))+','+
                    ((currentJob.travel/100).toFixed(2))+','+
                    ((currentJob.car_wash/100).toFixed(2))+','+
                    ((currentJob.parts/100).toFixed(2))+','+
                    ((currentJob.transport_services/100).toFixed(2))+','+
                    ((currentJob.hotel/100).toFixed(2))+','+
                    ((currentJob.electric_charge_cost/100).toFixed(2))+','+
                    ((currentJob.electric_charging_time/100).toFixed(2))+','+
                    ((currentJob.truck_fuel/100).toFixed(2))+','+
                    ((currentJob.truck_travel/100).toFixed(2))+','+
                    ((currentJob.air/100).toFixed(2))+','+
                    ((currentJob.food/100).toFixed(2))+','+
                    ((currentJob.water/100).toFixed(2))+','+
                    ((currentJob.coolant/100).toFixed(2))+','+
                    ((currentJob.parking/100).toFixed(2))+','+
                    (jobProfit.toFixed(2))+','+
                    grossProfitPercentage+','+"\n";
                });
            profitedRecords.push(
                <tr key="last-row-total">
                    <td className="job-ref-font16 text-center" colSpan="6">Total</td>
                    <td>&pound;{jobTotals.toFixed(2)}</td>
                    <td>&nbsp;</td>
                    <td>&pound;{adminTotals.toFixed(2)}</td>
                    <td>&nbsp;</td>
                    <td>&pound;{driverTotals.toFixed(2)}</td>
                    
                    <td>&pound;{cost_in_pence_final_total.toFixed(2)}</td>
                    <td>&pound;{expenses_approval_fuelTotal.toFixed(2)}</td>

                    <td>&pound;{customer_charged_vehicle_movementsSum.toFixed(2)}</td>
                    <td>&pound;{vehicle_movementsTotal.toFixed(2)}</td>
                    <td>&pound;{toll_roadTotal.toFixed(2)}</td>
                    <td>&pound;{waitingtimeTotal.toFixed(2)}</td>
                    <td>&pound;{storageTotal.toFixed(2)}</td>
                    <td>&pound;{breakdownTotal.toFixed(2)}</td>
                    <td>&pound;{travelTotal.toFixed(2)}</td>
                    <td>&pound;{car_washTotal.toFixed(2)}</td>
                    <td>&pound;{partsTotal.toFixed(2)}</td>
                    <td>&pound;{transport_servicesTotal.toFixed(2)}</td>
                    <td>&pound;{hotelTotal.toFixed(2)}</td>
                    <td>&pound;{electric_charge_costTotal.toFixed(2)}</td>
                    <td>&pound;{electric_charging_timeTotal.toFixed(2)}</td>
                    <td>&pound;{truck_fuelTotal.toFixed(2)}</td>
                    <td>&pound;{truck_travelTotal.toFixed(2)}</td>
                    <td>&pound;{airTotal.toFixed(2)}</td>
                    <td>&pound;{foodTotal.toFixed(2)}</td>
                    <td>&pound;{waterTotal.toFixed(2)}</td>
                    <td>&pound;{coolantTotal.toFixed(2)}</td>
                    <td>&pound;{parkingTotal.toFixed(2)}</td>
                    <td>&pound;{profitTotals.toFixed(2)}</td>
                    <td>{/* {grossTotals}% */}</td>
                    {/*<td>&pound;{profitTotals_customer.toFixed(2)}</td>*/}
                </tr>
            );
            downloadableCsvDataInvoiced = downloadableCsvDataInvoiced +
                                        'Total'+','+
                                        ''+','+
                                        ''+','+
                                        ''+','+
                                        ''+','+
                                        ''+','+
                                        (jobTotals.toFixed(2))+','+
                                        ''+','+
                                        (adminTotals.toFixed(2))+','+
                                        ''+','+
                                        (driverTotals.toFixed(2))+','+
                                        (cost_in_pence_final_total.toFixed(2))+','+
                                        (expenses_approval_fuelTotal.toFixed(2))+','+
                                        (customer_charged_vehicle_movementsSum.toFixed(2))+','+
                                        (vehicle_movementsTotal.toFixed(2))+','+
                                        (toll_roadTotal.toFixed(2))+','+
                                        (waitingtimeTotal.toFixed(2))+','+
                                        (storageTotal.toFixed(2))+','+
                                        (breakdownTotal.toFixed(2))+','+
                                        (travelTotal.toFixed(2))+','+
                                        (car_washTotal.toFixed(2))+','+
                                        (partsTotal.toFixed(2))+','+
                                        (transport_servicesTotal.toFixed(2))+','+
                                        (hotelTotal.toFixed(2))+','+
                                        (electric_charge_costTotal.toFixed(2))+','+
                                        (electric_charging_timeTotal.toFixed(2))+','+
                                        (truck_fuelTotal.toFixed(2))+','+
                                        (truck_travelTotal.toFixed(2))+','+
                                        (airTotal.toFixed(2))+','+
                                        (foodTotal.toFixed(2))+','+
                                        (waterTotal.toFixed(2))+','+
                                        (coolantTotal.toFixed(2))+','+
                                        (parkingTotal.toFixed(2))+','+
                                        (profitTotals.toFixed(2))+','+
                                        grossTotals+','+"\n";
        }else{
            profitedRecords.push(
                <tr key='no-records'><td colSpan="35" className='text-center'>No Records</td></tr>
            );
        }
        
        return (
            <div className="container-fluid">
                <div className="col-md-6">
                    <h2>Profit Report</h2>
                    <br/>
                </div>
                
                <div className="row">
                    <div className="col-md-1">
                        <label><h5>Select Start Date:</h5></label><br/>
                        <DatePicker todayButton={"Today"} dateFormat="dd/MM/yyyy" onChange={this.handleStartDateChange} selected={this.state.startDate}/>
                    </div>
                    <div className="col-md-1">
                        <label><h5>Select End Date:</h5></label><br/>
                        <DatePicker todayButton={"Today"} dateFormat="dd/MM/yyyy" onChange={this.handleEndDateChange} selected={this.state.endDate}/>
                    </div>
                    <div className="col-md-3 col-sm-12">
                        <label><h5>Select Customer</h5></label><br/>
                            <div>
                                <StatefulMultiSelect
                                    options={this.state.customers}
                                    selected={selectedCustomers}
                                    onSelectedChanged={this.handleCustomerSelection}
                                        overrideStrings={{
                                            selectSomeItems: "Select Customers...",
                                            allItemsAreSelected: "All Customers are Selected",
                                            selectAll: "Select All",
                                            search: "Search Customer",
                                        }}
                                    />
                            </div>
                    </div>
                    <div className="col-md-2">
                        <div className="form-group">
                            <button className="btn btn-lg btn-success invoiced-btn-margin" onClick={(e) => this.handleInvoicedJobsReportGeneration(e)}>
                                   <i className="fa fa-save"></i> Generate Profit Report
                            </button>
                        </div>
                    </div>
                    <div className="col-md-2">
                        <div className="form-group">
                            <button className="btn btn-primary btn-lg invoiced-btn-margin"
                                    onClick={(e) => {
                                    this.download(this.state.downloadReportName, downloadableCsvDataInvoiced);
                                  }}>
                                <i className="fa fa-download"></i> Download Profit Report
                            </button>
                        </div>
                    </div>
                    <div className="col-md-3">
                        <label className="alert alert-primary invoiced-btn-margin"><b>{this.state.profitReportData.length} jobs found..</b></label>
                    </div>             
                </div>
                <div className="row">
                    <div className="col-md-12 col-sm-12">
                        <div className="daily-delivered-report-tbl-scroll">
                            <table className="daily-delivered-report-tbl">
                                <thead className="sticky-top-without-zindex bg-light">
                                    <tr>
                                        <th>Job Ref</th>
                                        <th>Reg/VIN</th>
                                        <th>Customer</th>
                                        <th>Driver</th>
                                        <th>Status</th>
                                        <th>Driver Completed Date</th>
                                        <th>Job Price</th>
                                        <th>Mileage</th>
                                        <th>Admin Fee</th>
                                        <th>Fuel Incl</th>
                                        <th>Driver Price</th>
                                        <th>Driver Expense</th>
                                        <th>Fuel</th>
                                        <th>Customer Charge Vehicle Movements</th>
                                        <th>Vehicle Movements</th>
                                        <th>Toll Road</th>
                                        <th>Waitingtime</th>
                                        <th>Storage</th>
                                        <th>Breakdown</th>
                                        <th>Travel</th>
                                        <th>Car Wash</th>
                                        <th>Parts</th>
                                        <th>Transport Services</th>
                                        <th>Hotel</th>
                                        <th>Electric Charge Cost</th>
                                        <th>Electric Charging Time</th>
                                        <th>Truck Fuel</th>
                                        <th>Truck Travel</th>
                                        <th>Air</th>
                                        <th>Food</th>
                                        <th>Water</th>
                                        <th>Coolant</th>
                                        <th>Parking</th>
                                        <th>Profit</th>
                                        <th>Gross Profit %</th>
                                        {/*<th>Profit Total</th>*/}
                                    </tr>
                                </thead>
                                <tbody>
                                {this.state.isLoading ?
                                (<tr><td colSpan="35"><span className="add-loading-text">
                                        <i className="fa fa-spinner fa-pulse"></i></span></td></tr>) :
                                    profitedRecords
                                }
                                </tbody>
                            </table>
                        </div>
                        <br/><br/><br/>
                    </div>
                </div>
            </div>
        );
    }
}
if (document.getElementById('react-component-g4-logistics-portal-profit_report')) {
    ReactDOM.render(
        <ProfitReport message_if_none = 'Nothing to report on.' />,
        document.getElementById('react-component-g4-logistics-portal-profit_report')
    );
}